import { Component } from '@angular/core';
import { DISEASE_TAGS } from 'shared/constants';
import { Page, Section, SubSection } from 'shared/location-enums';
import { PATHS } from 'shared/paths';
import { Article } from 'shared/types';
import { ArticleService } from 'src/app/services/article.service';
import { DiseaseService } from 'src/app/services/disease.service';

@Component({
    selector: 'disease-multidisciplinary',
    templateUrl: './disease-multidisciplinary.component.html',
    styleUrls: ['./disease-multidisciplinary.component.scss'],
})
export class DiseaseMultidisciplinaryComponent {
    public textHeader = 'Multidisciplinary';

    public imgPath = PATHS.articleImages;

    public titleKA: Article;
    public bodyKA: Article;
    public pediatricsKA: Article;
    public pediatricsKAShouldShow = false;

    constructor(private articleService: ArticleService, private diseaseService: DiseaseService) {
        this.titleKA = this.articleService.getOne(Page.diagnosis, Section.careCenters, SubSection.sectionHeader, undefined, undefined, false);
        this.textHeader = this.titleKA.title;

        this.bodyKA = this.articleService.getOne(Page.diagnosis, Section.careCenters, SubSection.parent, undefined, undefined, false);

        // add replacement for disease name
        this.bodyKA.bodyText = this.bodyKA.bodyText.replace('${DiseaseName}', this.diseaseService.disease.name);

        // in the Multidisciplinary section ONLY WHEN the disease is tagged with the Pediatrics specialist tag
        this.pediatricsKAShouldShow = this.diseaseService.disease.tagsSpecialist.includes(DISEASE_TAGS.pediatrics);
        this.pediatricsKA = this.articleService.getOne(Page.diagnosis, Section.careCenters, SubSection.pediatrics);
    }
}
